"use client";

import { useEffect } from "react";
import { useRouter } from "next/router";

// トップページには表示コンテンツが存在しない(初期実装から空)ため、
// ログイン後の着地点として受信トレイへ誘導する。認証ガードは /chat 側の
// 既存処理に委ねる(未認証なら従来どおりログインへ飛ぶ)。
export default function Home() {
  const router = useRouter();

  useEffect(() => {
    router.replace("/chat");
  }, [router]);

  return <></>;
}
